import React, { useState } from "react";
import "../styles/Faqs.scss";

const faqs = [
    {
        question: "1.What is the concept of Resort NA Project?",
        answer: (
            <>
                <p>
                    A <b>Resort NA Project</b> refers to the development of a resort on
                    Non-Agricultural (NA) land, which has been converted from its original
                    agricultural status and is designated for non-farming construction
                    purposes such as tourism, residential, or commercial projects.
                </p>

                <p>Here's a breakdown of the concept:</p>

                <ul>
                    <li>
                        <strong>NA Land:</strong> Non-agricultural land officially approved
                        for construction.
                    </li>
                    <li>
                        <strong>Resort NA Project:</strong> Developers or individuals plan
                        and build resort-like facilities on this approved land.
                    </li>
                    <li>
                        <strong>Purpose:</strong>
                        <ul>
                            <li>
                                <b>Hospitality –</b> Creating a destination for leisure,
                                vacation, and relaxation.
                            </li>
                            <li>
                                <b>Investment –</b> Developers sell individual NA plots to
                                buyers who wish to construct their own holiday homes or
                                cottages.
                            </li>
                            <li>
                                <b>Development –</b> Land is zoned and approved for villas,
                                holiday homes, swimming pools, and other amenity spaces.
                            </li>
                        </ul>
                    </li>
                </ul>
            </>
        ),
    },
    {
        question: "2.Lonavalley comes under which Sanction?",
        answer: (
            <p>
                Lonavalley comes under{" "}
                <b>Pune Metropolitan Region Development Authority (PMRDA)</b>. It is a
                government-owned body responsible for integrated planning and
                development of major infrastructure and townships within the Pune
                Metropolitan Region, including the metro, ring road, and new residential
                zones to ensure sustainable growth and a high quality of life for
                residents.
            </p>
        ),
    },
    {
        question: "3.Is loan facility available?",
        answer: (
            <p>
                As it is a Resort NA plotting project, we offer flexible payment schedules and milestone-based plans to make the investment convenient and manageable for our buyers.
            </p>
        ),
    },
    // {
    //     question: "4.How will be the payment schedule?",
    //     answer: (

    //         <ul>

    //             <p>“The payment schedule is designed to be simple and milestone-based:</p>

    //             <li>10% – At the time of booking (to reserve your plot).</li>
    //             <li>10% – Within 30 days to confirm the booking.</li>
    //             <li>
    //                 60% – At the time of Agreement.
    //             </li>
    //             <li>
    //                 10% – On development stage
    //             </li>
    //             <li>
    //                 10% – At possession
    //             </li>

    //             <p>This structured plan ensures flexibility while securing your investment step by step.”</p>

    //         </ul>
    //     ),
    // },
    {
        question: "5.What will be the FSI?",
        answer: (
            <p>
                The <b> permissible FSI at  Lonavalley is 0.10 </b>, which is <b> ideal for building elegant farmhouses and spacious second homes.</b> It ensures ample open space, greenery, and a premium low-density living experience.
            </p>
        ),
    },
];

export default function FAQ() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq" >
            <div className="faq-container">
                {/* Left side */}
                <div className="faq-left">
                    <h2>Frequently asked questions</h2>
                    <div className="faq-card">
                        <h3>Still have questions?</h3>
                        <p>
                            Can’t find the answer to your questions? Connect to us
                            we’ll get back to you as soon as possible!
                        </p>
                        <a href="#contact">Connect us Now</a>
                    </div>
                </div>

                {/* Right side */}
                <div className="faq-right">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? "active" : ""}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-question">
                                <h4>{faq.question}</h4>
                                <span className={`arrow ${activeIndex === index ? "open" : ""}`}>
                                    ▼
                                </span>
                            </div>
                            <div
                                className="faq-answer"
                                style={{
                                    maxHeight: activeIndex === index ? "1000px" : "0",
                                }}
                            >
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
